const PENDING = 'pending';
const REJECTED = 'rejected';
const APPROVED = 'approved';

export default class ReviewStatus {
    static get PENDING() {
        return PENDING;
    }

    static get REJECTED() {
        return REJECTED;
    }

    static get APPROVED() {
        return APPROVED;
    }
}
